import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import QuickInvoice from './pages/QuickInvoice/QuickInvoice';
import PaymentStatus from './pages/PaymentStatus/PaymentStatus';
import reportWebVitals from './reportWebVitals';
import { configureStore } from './store/configureStore';
import * as router from './constants/router';
import { InvoiceContectElement } from './components/context/invoiceData';

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
      },
    },
  },
});

const { store } = configureStore();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <InvoiceContectElement>
          <Router>
            <Routes>
              <Route path={router.QUICK_INVOICE_PAGE} element={<QuickInvoice />} />
              <Route path={router.PAYMENT_STATUS_PAGE} element={<PaymentStatus />} />
            </Routes>
          </Router>
        </InvoiceContectElement>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
